import { merge, Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { FadeAnimation } from '@app/core/animations/fade.transition';
import { TourService } from '@app/core/services/tour.service';
import { shareRef } from '@app/shared/operators/share-ref.operator';
import { TourIntercomService } from '@app/core/services/tour-intercom.service';
import { lastValue } from '@app/shared/operators/last-value.operator';

@Component({
  standalone: false,
  selector: 'adspt-tour-button',
  templateUrl: 'tour-button.component.html',
  styleUrls: ['tour-button.component.scss'],
  animations: [FadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourButtonComponent {
  @Input()
  disableStartTourWrapper?: boolean;

  readonly ts = inject(TourService);

  readonly tis = inject(TourIntercomService);

  readonly subject = merge(this.ts.subject, this.tis.subject).pipe(shareRef());

  readonly tourEnabled$: Observable<boolean> = this.subject.pipe(
    map(({ tourEnabled }) => tourEnabled),
    debounceTime(1),
    shareRef(),
  );

  openTour() {
    const subject = lastValue(this.subject);

    if (subject.source === 'intercom' && subject.instance) {
      this.tis.start(subject.instance);
    } else {
      this.ts.start();
    }
  }
}
